<div class="content__inner">
    <header class="content__title">
        <h1>{{ "distributors.overview.list.title" | translate }}</h1>
        <small>{{ "distributors.overview.list.subtitle" | translate }}</small>
    </header>

    <div class="card" *appHasPermission="'CHECKLIST.LIST'">
        <div class="card-body">
            <h4 class="card-title">{{ "distributors.overview.list.card.title" | translate }}</h4>

            <div class="form-group">
                <label>{{ "distributors.overview.filter.display.title" | translate }}</label>
                <div class="checkbox">
                    <input type="checkbox" id="showAsm" [checked]="showAsm" (change)="showAsm = !showAsm" />
                    <label class="checkbox__label" for="showAsm">{{ "distributors.overview.filter.display.showAsm" | translate }}</label>
                </div>
                <div class="checkbox">
                    <input type="checkbox" id="isActiveOnly" [checked]="isActiveOnly" (change)="isActiveOnly = !isActiveOnly; isInactiveOnly = false; onChangeFilter()" />
                    <label class="checkbox__label" for="isActiveOnly">{{ "distributors.overview.filter.display.isActiveOnly" | translate }}</label>
                </div>
                <div class="checkbox">
                    <input type="checkbox" id="isInactiveOnly" [checked]="isInactiveOnly" (change)="isInactiveOnly = !isInactiveOnly; isActiveOnly = false; onChangeFilter()" />
                    <label class="checkbox__label" for="isInactiveOnly">{{ "distributors.overview.filter.display.isInactiveOnly" | translate }}</label>
                </div>
                <div class="checkbox">
                    <input type="checkbox" id="isDisabledOnly" [checked]="isDisabledOnly" (change)="isDisabledOnly = !isDisabledOnly; onChangeFilter()" />
                    <label class="checkbox__label" for="isDisabledOnly">{{ "distributors.overview.filter.display.isDisabledOnly" | translate }}</label>
                </div>
                <div class="checkbox">
                    <input type="checkbox" id="isMissingCoords" [checked]="isMissingCoords" (change)="isMissingCoords = !isMissingCoords; onChangeFilter()" />
                    <label class="checkbox__label" for="isMissingCoords">{{ "distributors.overview.filter.display.isMissingCoords" | translate }}</label>
                </div>
            </div>

            <div class="row">
                <div class="col-md-2">
                    <div class="form-group">
                        <label>{{ "distributors.overview.filter.status.title" | translate }}</label>
                        <div class="select">
                            <select class="form-control" #statusSelect [(ngModel)]="isStatus" (change)="onStatusSelected()">
                                <option [value]="undefined">{{ "distributors.overview.filter.status.options.all" | translate }}</option>
                                <option *ngFor="let statusOption of statusOptions" [value]="statusOption">{{ "distributors.overview.filter.status.options." + statusOption | translate }}</option>
                            </select>
                            <i class="form-group__bar"></i>
                        </div>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label>{{ "distributors.overview.filter.lifecycleStatus.title" | translate }}</label>
                        <div class="select">
                            <select class="form-control" #lifecycleStatusSelect [(ngModel)]="selectedLifecycleStatusFilter" (change)="onChangeFilter()">
                                <option [value]="undefined">{{ "distributors.overview.filter.lifecycleStatus.options.all" | translate }}</option>
                                <option *ngFor="let lifecycleStatusFilterItem of lifecycleStatusFilterItems" [value]="lifecycleStatusFilterItem">{{ lifecycleStatusFilterItem }}</option>
                            </select>
                            <i class="form-group__bar"></i>
                        </div>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "distributors.overview.filter.salesline.title" | translate }}</label>
                        <input class="form-control" placeholder="{{ 'distributors.overview.filter.salesline.title' | translate }}" type="text" [(ngModel)]="saleslineFilter" (keyup)="saleslineChanged()" /><i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "distributors.overview.filter.asm.title" | translate }}</label>
                        <ng-select id="asmSelection" [items]="asmItems" (change)="asmChanged()" [placeholder]="'distributors.overview.filter.asm.placeholder' | translate" [(ngModel)]="asmFilter"> </ng-select>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-2">
                    <div class="form-group">
                        <label>{{ "distributors.overview.filter.postcode.from" | translate }}</label>
                        <input
                            class="form-control"
                            placeholder="{{ 'distributors.overview.filter.postcode.title' | translate }}"
                            type="text"
                            [(ngModel)]="fromPostCode"
                            (keyup)="postCodeChanged(fromPostCode)"
                            [pattern]="numbersOnlyPattern"
                        /><i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-2">
                    <div class="form-group">
                        <label>{{ "distributors.overview.filter.postcode.to" | translate }}</label>
                        <input class="form-control" placeholder="{{ 'distributors.overview.filter.postcode.title' | translate }}" type="text" [(ngModel)]="toPostCode" (keyup)="postCodeChanged(toPostCode)" [pattern]="numbersOnlyPattern" /><i
                            class="form-group__bar"
                        ></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "distributors.overview.filter.city.title" | translate }}</label>
                        <input class="form-control" placeholder="{{ 'distributors.overview.filter.city.title' | translate }}" type="text" [(ngModel)]="city" (keyup)="cityChanged()" /><i class="form-group__bar"></i>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <button type="button" (click)="selectAll()" class="btn btn-success btn--icon-text float-left ml-2 mb-2">{{ "distributors.buttons.selectAll" | translate }}</button>
                    <button type="button" (click)="deselectAll()" class="btn btn-success btn--icon-text float-left ml-2 mb-2">{{ "distributors.buttons.deselectAll" | translate }}</button>
                </div>
            </div>


            <mat-form-field class="search-field">
                <mat-label>{{ "global.datatable.search" | translate }}</mat-label>
                <input matInput [formControl]="pageState.searchInputControl" [autocomplete]="'off'" />
            </mat-form-field>

            <!-- Table -->
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)" [matSortActive]="pageState.sortState.active" [matSortDirection]="pageState.sortState.direction">
                <ng-container matColumnDef="selected">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let row">
                        <input type="checkbox" id="selected_{{ row._id }}" [(ngModel)]="selectedRows[row._id]" (change)="onSelectionToggle()" />
                    </td>
                </ng-container>
                
                <ng-container matColumnDef="vo">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "distributors.props.vo" | translate }}</th>
                    <td mat-cell *matCellDef="let row">{{ row.vo }}</td>
                </ng-container>
                
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "distributors.props.name" | translate }}</th>
                    <td mat-cell *matCellDef="let row" style="white-space: nowrap">{{ row.name }}<br />{{ row.street }}<br />{{ row.postcode }} {{ row.city }}</td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "distributors.props.status" | translate }}</th>
                    <td mat-cell *matCellDef="let row">{{ row.status }}</td>
                </ng-container>

                <ng-container matColumnDef="lifecycleStatus">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "distributors.props.lifecycleStatus" | translate }}</th>
                    <td mat-cell *matCellDef="let row" style="max-width: 130px">{{ row.lifecycleStatus }}</td>
                </ng-container>

                <ng-container matColumnDef="salesline">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "distributors.props.salesline" | translate }}</th>
                    <td mat-cell *matCellDef="let row">{{ row.salesline }}</td>
                </ng-container>

                <ng-container matColumnDef="checklistLastCreated">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "distributors.props.checklistLastCreated" | translate }}</th>
                    <td mat-cell *matCellDef="let row">{{ row.checklistLastCreated | date : UTCDATEFORMAT : "+0" }}</td>
                </ng-container>

                <ng-container matColumnDef="checklistLastCreatedBy">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "distributors.props.checklistLastCreatedBy" | translate }}</th>
                    <td mat-cell *matCellDef="let row">{{ row.formatChecklistLastCreatedBy() }}</td>
                </ng-container>

                <ng-container matColumnDef="asm">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "distributors.props.asm" | translate }}</th>
                    <td mat-cell *matCellDef="let row" class="asm" [class]="{ 'd-none': !showAsm }">{{ row.asm }}</td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td class="text-right nowrap" mat-cell *matCellDef="let row">
                        <i
                            (click)="showChecklists(row._id)"
                            class="zmdi zmdi-collection-text zmdi-hc-fw tableIcon"
                            *appHasPermission="'CHECKLIST.READ'"
                            [tooltip]="'distributors.buttontooltips.downloadPDF' | translate"
                            placement="bottom"
                        ></i>
                        <i (click)="viewDistributor(row._id)" class="zmdi zmdi-edit zmdi-hc-fw tableIcon" *appHasPermission="'DISTRIBUTORS.READ'" [tooltip]="'distributors.buttontooltips.edit' | translate" placement="bottom"></i>
                    </td>
                </ng-container>

                <ng-container matColumnDef="disabled">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td class="text-right nowrap" mat-cell *matCellDef="let row">
                        <span *appHasPermission="'DISTRIBUTORS.DISABLE'">
                            <i (click)="changeState(row)" class="zmdi zmdi-crop-square zmdi-hc-fw tableIcon" *ngIf="!row.disabled"></i>
                            <i (click)="changeState(row)" class="zmdi zmdi-minus-square zmdi-hc-fw tableIcon text-danger" *ngIf="row.disabled"></i>
                        </span>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
            </div>

            <mat-paginator
                class="flex inset-x-0 bottom-0 border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent"
                #paginator
                [length]="pageState.totalRows"
                [pageIndex]="pageState.currentPage"
                [pageSize]="pageState.pageSize"
                [pageSizeOptions]="pageState.pageSizeOptions"
                showFirstLastButtons
                (page)="pageChanged($event)"
            >
            </mat-paginator>

            <div class="col-12 mt-5">
                <span>
                    <button type="button" (click)="showTourDistributionDialog()" class="btn btn-success btn--icon-text float-right ml-2 mb-2" [disabled]="selectedTotal === 0">
                        <i class="zmdi zmdi-check"></i> {{ "distributors.buttons.addSelectionToTour" | translate }} {{ "(" + selectedTotal + ")" }}
                    </button>
                </span>
            </div>
        </div>
    </div>
</div>
